export default "__VITE_ASSET__Bc2nNuZO__"